<template>
  <div id="departments">
	<el-card style="margin: 0 10px;">
		<div style="height: 20px;">
			<span v-for="item in item_tab" style="display: inline-block;width: 80px;text-align: center;border-right: 1px solid #000;color: #2D8CF0;">{{item.tabName}}</span>
			<el-button v-if="editShow" type="primary" size="small" style="float: right;" @click="editInfo">{{$t('message.button.edit')}}</el-button>
			<el-button v-if="!editShow" type="success" size="small" style="float: right;" @click="saveInfo">{{$t('message.button.save')}}</el-button>
			<el-button v-if="!editShow" type="" size="small" style="float: right;margin-right: 10px;" @click="delInfo">{{$t('message.button.cancel')}}</el-button>
		</div>
		<div class="line01"></div>
		<div v-if="editShow" style="padding-top: 20px;">
			<div style="font-size: 16px;">系统的首选项</div>
			<div class="line01" style="padding: 5px 0 0 0;"></div>
			<ul v-for="item in item_info" class="textForm">
				<li>
					<el-col :span="5" class="left_info">{{item.name}}</el-col>
					<el-col style="text-align: center;width: 20px;">:</el-col>
					<el-col :span="18" >{{item.val}}</el-col>
				</li>
			</ul>
			<div style="font-size: 16px;margin-top: 30px;">格式的首选项</div>
			<div class="line01" style="padding: 5px 0 0 0;"></div>
			<ul v-for="item in item_info2" class="textForm">
				<li>
					<el-col :span="5" class="left_info">{{item.name}}</el-col>
					<el-col style="text-align: center;width: 20px;">:</el-col>
					<el-col :span="18">{{item.val}}</el-col>
				</li>
			</ul>
			<div style="font-size: 16px;margin-top: 30px;">显示的首选项</div>
			<div class="line01" style="padding: 5px 0 0 0;"></div>
			<ul v-for="item in item_info3" class="textForm">
				<li>
					<el-col :span="5" class="left_info">{{item.name}}</el-col>
					<el-col style="text-align: center;width: 20px;">:</el-col>
					<el-col :span="18">{{item.val}}</el-col>
				</li>
			</ul>
		</div>
		
		<div v-if="!editShow">
			<div style="font-size: 16px;padding-top: 20px;">系统的首选项</div>
			<div class="line01" style="padding: 5px 0 0 0;"></div>
			<el-form ref="form" :model="editFormList" label-width="30%" size="mini" class="editForm" >
				<el-form-item :label="item.name" v-for="item in editFormData" style="margin-top: 10px;">
				    <el-select v-model="item.val"  placeholder="请选择活动区域">
				      <el-option :label="item2.val_two" :value="item2.val_two" v-for="item2 in item.chose" ></el-option>
				    </el-select>
				  </el-form-item>
			</el-form>
			<div style="font-size: 16px;margin-top: 30px;">格式的首选项</div>
			<div class="line01" style="padding: 5px 0 0 0;"></div>
			<el-form ref="form" :model="editFormList2" label-width="30%" size="mini" class="editForm" >
				<el-form-item :label="item.name" v-for="item in editFormData2" style="margin-top: 10px;">
				    <el-select v-model="item.val"  placeholder="请选择活动区域">
				      <el-option :label="item2.val_two" :value="item2.val_two" v-for="item2 in item.chose" ></el-option>
				    </el-select>
				  </el-form-item>
			</el-form>
			
			<div style="font-size: 16px;margin-top: 30px;">显示的首选项</div>
			<div class="line01" style="padding: 5px 0 0 0;"></div>
			<el-form ref="form" :model="editFormList3" label-width="30%" size="mini" class="editForm" >
				<el-form-item :label="item.name" v-for="item in editFormData3" style="margin-top: 10px;">
				    <el-select v-model="item.val"  placeholder="请选择活动区域">
				      <el-option :label="item2.val_two" :value="item2.val_two" v-for="item2 in item.chose" ></el-option>
				    </el-select>
				  </el-form-item>
			</el-form>
		</div>
		
	</el-card>
	
  </div>
</template>

<style scoped>
	.editForm .el-form-item--mini.el-form-item{
		margin: 0;
	}
	.left_info {
		text-align: right;
	}
	.textForm li {
		height: 10px;
	}
	
	div {
		font-size: 12px;
	}
</style>

<script>
import axios from "axios";
export default {
  data() {
    return {
		editFormList:{
			
		},
		editFormList2:{
			
		},
		editFormList3:{
			
		},
		
		editFormData:[{
			name:"首选客户端",
			val:"Web Client",
			chose:[{
				val_two:"Java Client"
			},{
				val_two:"Web Client"
			}]
		},{
			name:"首选文件管理器",
			val:"iFS",
			chose:[{
				val_two:"ifs"
			}]
		},{
			name:"接收电子邮件通知",
			val:"是",
			chose:[{
				val_two:"是"
			},{
				val_two:"否"
			}]
		},{
			name:"下载结构文件",
			val:"不允许",
			chose:[{
				val_two:"不允许"
			},{
				val_two:this.$t('message.tips.tip')
			},{
				val_two:"允许"
			}]
		},{
			name:"BOM 变量配置首选项",
			val:"已禁用",
			chose:[{
				val_two:"内部配置器"
			},{
				val_two:"外部配置器"
			}]
		}],
		
		editFormData2:[{
			name:"语言",
			val:"简体中文",
			chose:[{
				val_two:"简体中文"
			},{
				val_two:"英语"
			}]
		},{
			name:"工作周设置",
			val:"iFS",
			chose:[{
				val_two:"1周"
			}]
		},{
			name:"首选日期格式",
			val:"MM/DD/yyyy",
			chose:[{
				val_two:"dd/MM/yyyy"
			},{
				val_two:"MM.dd.yyyy"
			}]
		},{
			name:"时区",
			val:"(GMY+08:00)北京,重庆,香港,乌鲁木齐",
			chose:[{
				val_two:"(GMY+03:00)巴格达"
			},{
				val_two:"(GMY+08:00)尼泊尔时间（加德曼都）"
			},{
				val_two:"(GMY+08:00)北京,重庆,香港,乌鲁木齐"
			}]
		},{
			name:"首选时间格式:",
			val:"HH:mm:ss z(10.00.00 AM PST)",
			chose:[{
				val_two:"HH:mm:ss z(10.00.00 AM PST)"
			},{
				val_two:"hh:mm:ss aaa z (10.00.00 AM PST)"
			}]
		},{
			name:"编号格式",
			val:"987，654，321.09",
			chose:[{
				val_two:"987，654，321.09"
			},{
				val_two:"987 654 321，09"
			}]
		},{
			name:"首选货币:",
			val:"USD",
			chose:[{
				val_two:"CNY"
			},{
				val_two:"USD"
			}]
		}],
		editFormData3:[{
			name:"首选起始页",
			val:"待处理任务",
			chose:[{
				val_two:"工作流"
			},{
				val_two:"通知"
			},{
				val_two:"仪表板"
			},{
				val_two:"待处理任务"
			}]
		},{
			name:"回应编辑模式",
			val:"基本",
			chose:[{
				val_two:"高级表编写",
				val_two:"高级向导编写",
				val_two:"基本",
			}]
		},{
			name:"编码类型",
			val:"UTF-8",
			chose:[{
				val_two:"繁体中文"
			},{
				val_two:"简体中文"
			},{
				val_two:"英语"
			}]
		},{
			name:"缩略图",
			val:"关闭",
			chose:[{
				val_two:"关闭"
			},{
				val_two:"打开"
			}]
		},{
			name:"表显示模式:",
			val:"标准",
			chose:[{
				val_two:"标准"
			},{
				val_two:"缩略图"
			}]
		},{
			name:"搜索显示模式",
			val:"标准",
			chose:[{
				val_two:"标准"
			},{
				val_two:"带缩略图"
			}]
		},{
			name:"显示时间表:",
			val:"否",
			chose:[{
				val_two:"否"
			},{
				val_two:"是"
			}]
		}],
		form: {
		          name: '',
		          region: '',
		          date1: '',
		          date2: '',
		          delivery: false,
		          type: [],
		          resource: '',
		          desc: ''
		        },
		editShow:true,
		item_tab: [{
			tabName: "系统的首选项"
		},{
			tabName: " 格式的首选项"
		},{
			tabName: " 显示的首选项"
		}],
		
		item_info: [{
			name:"首选客户端",
			val:"Web Client"
		},{
			name:"首选文件管理器",
			val:"iFS"
		},{
			name:"接收电子邮件通知",
			val:"是"
		},{
			name:"下载结构文件",
			val:"不允许"
		},{
			name:"BOM 变量配置首选项",
			val:"已禁用"
		}],
		item_info2: [{
			name:"语言",
			val:"简体中文"
		},{
			name:"工作周设置",
			val:"iFS"
		},{
			name:"首选日期格式",
			val:"MM/DD/yyyy"
		},{
			name:"时区",
			val:"(GMY+08:00)北京,重庆,香港,乌鲁木齐"
		},{
			name:"首选时间格式:",
			val:"HH:mm:ss z(10.00.00 AM PST)"
		},{
			name:"编号格式",
			val:"987，654，321.09"
		},{
			name:"首选货币:",
			val:"USD"
		}],
		item_info3: [{
			name:"首选起始页",
			val:"待处理任务"
		},{
			name:"回应编辑模式",
			val:"基本"
		},{
			name:"编码类型",
			val:"UTF-8"
		},{
			name:"缩略图",
			val:"关闭"
		},{
			name:"表显示模式:",
			val:"标准"
		},{
			name:"搜索显示模式",
			val:"标准"
		},{
			name:"显示时间表:",
			val:"否"
		}],
	}
  },
	mounted(){
	},
  methods: {
	  editInfo() {
		  this.editShow = !this.editShow;
	  },
	  saveInfo() {
		  this.editShow = !this.editShow;
	  },
	  delInfo() {
		  this.editShow = !this.editShow;
	  },
  },
  created() {
    
  }
};
</script>